export enum TranslationResources {
	Default = "default",
	AdvisoryManagement = "advisoryManagement",
	CommissionDistribution = "commissionDistribution",
}
